import { createStronglyTypedTiptapNode } from "@blocknote/core";
import { columnNormalization } from "./columnNormalization";
import { columnDnd } from "./columnDnd";

/**
 * 다단(컬럼) 레이아웃의 컨테이너 노드 `columnList`.
 *
 * @blocknote/xl-multi-column(AGPL)을 쓰지 않고, 코어가 이미 인지하는 노드 구조
 * (core/src/pm-nodes/README.md, MIT)를 직접 정의한다(라이선스 안전).
 *  - 코어 UniqueID가 ["blockContainer","columnList","column"]에 id 부여,
 *    blockToNode가 bnBlock 그룹 노드를 {id,...props,children}로 변환,
 *    getBlockInfoFromPos가 그룹 기반 처리.
 *  - nodeToBlock(직렬화)은 blockSchema에 스펙이 있어야 인식하므로, 이 노드를
 *    createBlockSpecFromStronglyTypedTiptapNode로 감싸 schema에 등록한다(HtmlPreview.tsx).
 *
 * 스키마(README):
 *   group:   "childContainer bnBlock blockGroupChild"
 *   content: "column column+"  (최소 2단)
 */
export const ColumnList = createStronglyTypedTiptapNode({
  name: "columnList",
  group: "childContainer bnBlock blockGroupChild",
  content: "column column+",

  addAttributes() {
    return {
      // 블록별 중앙 세로 구분선 표시 여부(드래그핸들 메뉴에서 토글). data-divider로 렌더.
      showDivider: {
        default: false,
        parseHTML: (element) => element.getAttribute("data-divider") === "true",
        renderHTML: (attributes) =>
          attributes.showDivider ? { "data-divider": "true" } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-node-type="columnList"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    const dom = document.createElement("div");
    dom.className = "bn-column-list";
    dom.setAttribute("data-node-type", "columnList");
    for (const [attribute, value] of Object.entries(HTMLAttributes)) {
      if (attribute !== "class") {
        dom.setAttribute(attribute, value as string);
      }
    }
    return { dom, contentDOM: dom };
  },

  // columnNormalization: 빈 컬럼/1단 columnList 자동 복구(unwrap).
  // columnDnd: 블록을 다른 블록 좌/우로 드롭하면 2단 컬럼 생성.
  addProseMirrorPlugins() {
    return [columnNormalization(), columnDnd()];
  },
});
